import * as PopoverPrimitive from '@radix-ui/react-popover';
import { clsx } from 'clsx';
import { ComponentPropsWithRef } from 'react';
import { space } from '../tokens.ts';
import { popoverContent } from './popover.css.ts';

const Popover = PopoverPrimitive.Root;
const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverTrigger = ({
  ref,
  className,
  ...props
}: ComponentPropsWithRef<typeof PopoverPrimitive.Trigger>) => (
  <PopoverPrimitive.Trigger ref={ref} className={className} {...props} />
);
PopoverTrigger.displayName = PopoverPrimitive.Trigger.displayName;

const PopoverContent = ({
  ref,
  children,
  className,
  side = 'top',
  align = 'center',
  sideOffset = space.s4,
  ...props
}: ComponentPropsWithRef<typeof PopoverPrimitive.Content>) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      side={side}
      collisionPadding={6}
      className={clsx(popoverContent, className)}
      {...props}
    >
      {children}
    </PopoverPrimitive.Content>
  </PopoverPrimitive.Portal>
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger };
